// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"styles_submitButton__TUoff"};